<template>
    <div class="electricity">
        <Title firstName="剩余电量" lastName="SOC-STATE OF CHARGE"/>
        <div class="echarts">
            <div class="edata">
                
                <div class="edataCon">
                    <p>剩余电量</p>
                    <p>{{hourPercent}}<span> %</span></p>
                </div>
                <div class="edataCon">
                    <p>配置容量</p>
                    <p>200<span> kWh</span></p>
                </div>
            </div>
            <div class="eview">
                <Graph :chartId="chartId" :seriesData="seriesData" :xData="xData" v-if="seriesData.length > 0"/>
            </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')

export default {
    data(){
        return {
            chartId:'soc',
            xData:['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00','24:00',],
            seriesData:[]
        }
    },
    components:{
        Title,Graph
    },
    computed:{
        hourPercent(){
            let now = this.seriesData[this.seriesData.length - 1] / 200 * 100
            return now
        }
    },
    mounted(){
        this.getSoc()
    },
    methods:{
        getSoc(){
            let arr = [40, 80, 120, 160, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 120, 40, 40, 40 ]
            let hour = new Date().getHours() + 1
            this.seriesData = arr.splice(0,hour)
        }
    }

}
</script>

<style lang="less" scoped>
    
    .electricity{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                display: flex;
                justify-content: space-around;
                padding: 2.5vh 0;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
            }

            .eview{
                padding: 0 0.5vw;
                height: 16vh;
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        
    }

</style>